<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3" style="height: 180px;">
            <div class="container mb-0 mt-5">
                <div class="row">
                    <div class="col-lg-12 mt-5">
                        <div class="text-left">
                            <h1 class="text-white" data-aos="fade-left">Saya ingin menutup akun Awanbisnis</h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-white pt-3">
            <div class="container mt-2">
                <p class="font-size-16 text-left" data-aos="fade-left">
                <section>
                    <li><strong>Melalui Email:</strong>
                        <ol type="a">
                            <li>Buka email baru dan alamatkan ke alamat email resmi dukungan pelanggan Awan: <a href="mailto:info@awanbisnis.com">info@awanbisnis.com</a>.</li>
                            <li>Subjek email harus mencantumkan "Permohonan Penutupan Akun Awan".</li>
                            <li>Jelaskan secara jelas dan singkat alasan Anda ingin menutup akun Awan Anda. Ini akan membantu tim dukungan pelanggan memproses permintaan Anda dengan lebih cepat.</li>
                            <li>Sertakan detail informasi akun Anda seperti nama pengguna, nomor telepon, alamat email yang terdaftar di akun, dan kode refferal jika perlu.</li>
                            <li>Kirim email ke alamat dukungan pelanggan Awan.</li>
                            <li>Tunggu konfirmasi dari tim dukungan pelanggan Awan melalui email terkait permohonan penutupan akun. Mereka akan memberi tahu Anda melalui email atau notifikasi di aplikasi ketika proses penutupan akun selesai.</li>
                        </ol>
                    </li>
                    <li><strong>Melalui Aplikasi Awan:</strong>
                        <ol type="a">
                            <li>Buka aplikasi Awan di perangkat Anda.</li>
                            <li>Masuk ke akun Anda jika belum masuk. Lalu, cari dan akses opsi "Pengaturan Akun" atau "Profil Saya".</li>
                            <li>Di dalam pengaturan akun, cari opsi yang berkaitan dengan penutupan atau penghapusan akun.</li>
                            <li>Ikuti instruksi yang diberikan di aplikasi untuk menyelesaikan proses penutupan akun. Ini mungkin melibatkan mengkonfirmasi keputusan Anda atau memberikan alasan penutupan akun.</li>
                            <li>Tunggu konfirmasi dari tim Awan. Mereka akan memberi tahu Anda melalui email atau notifikasi di aplikasi ketika proses penutupan akun selesai.</li>
                        </ol>
                    </li>
                </section>
                </p>
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: 'SyaratKetentuan',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        // title
        document.title = 'Syarat dan Ketentuan'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>